module.exports = __webpack_public_path__ + "img/目标2.38999260.png";